import api from "actions/api.js"


export function getLicenses(personid) {
    return api(`profile/${personid}/licenses`)
}

export function postLicense(record) {
    const { personid, license, authority, valid, eplevel, unlimited } = record
    if (unlimited === true) record = { personid, license, authority, eplevel, valid: null }
    else record = { personid, license, authority, valid, eplevel }

    return api("personlicense",
        {
            method: "POST",
            body: JSON.stringify(record)
        })
}

export function putLicense(record) {
    const { id, license, authority, valid, eplevel, unlimited } = record
    if (unlimited === true) record = { license, authority, eplevel, valid: null }
    else record = { license, authority, valid, eplevel }

    return api(`personlicense/${id}`,
        {
            method: "PUT",
            body: JSON.stringify(record)
        })
}

export function deleteLicense(id) {
    return api(`personlicense/${id}`,
        {
            method: "DELETE"
        })
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/licenses/api.js
 **/